import React, { useState } from "react";
import { Typography, Box, Button } from "@mui/material";
import { useContext } from "react";
import { DataContext } from "../context/DataContext";
import logTop from "../img/log-tp.png";
import styled from "@emotion/styled";
import { useEffect } from "react";
import { doc, onSnapshot } from "firebase/firestore";
import { db } from "../firebase";

const Complete = () => {
  const { appointmentUrl, whereFrom } = useContext(DataContext);
  const [isReady, setIsReady] = useState(false)

  const additionalUrl = localStorage.getItem('additional_url')

  useEffect(() => {
    const appointmentId = localStorage.getItem('appointment_id')
    if (appointmentId) {
      const unsuscribe = onSnapshot(doc(db, `appointment/${appointmentId}`), (doc) => {
        const data = doc.data()
        if (data.linkClicked) {
          setIsReady(true)
        }

        return () => {
          unsuscribe()
        }
      })
    }
  }, [])

  return (
    <div
      className="image-container set-full-height"
      style={{
        paddingTop: "100px",
        backgroundColor: '#2670de',
      }}
    >
      {isReady ? <>
        <Box
          sx={{
            margin: "0 auto",
            width: "50%",
            minWidth: "310px",
            minHeight: "310px",
            backgroundColor: "#fff",
            borderRadius: "6px",
            boxShadow:
              "0 16px 24px 2px rgb(0 0 0 / 14%), 0 6px 30px 5px rgb(0 0 0 / 12%), 0 8px 10px -5px rgb(0 0 0 / 20%)",
          }}
        >
          <Box sx={{ padding: "10px 0" }}>
            <Box
              sx={{
                "& p": { fontSize: "14px", color: "rgba(0,0,0, 0.87)" },
                margin: "30px 10px 40px",
                textAlign: "center",
                padding: "20px 0px",
              }}
            >
              <Typography>商談用のURLを発行しました。</Typography>
              <Typography>下記URLからアクセスお願い致します。</Typography>
              <Box>
                <Button
                  variant="contained"
                  sx={{
                    my: 3,
                    width: "70%",
                    textTransform: "none",
                    borderRadius: "10px",
                  }}
                  onClick={() => (window.location.href = appointmentUrl)}
                >
                  {appointmentUrl}
                </Button>
              </Box>
              {additionalUrl && <>
                <Box>
                  <Button
                    sx={{
                      width: 'auto',
                      textDecoration: "underline"
                    }}
                    onClick={() => window.open(additionalUrl, '_blank')}
                  >うまく繋がらない場合はこちら(日程調整)</Button>
                </Box>
              </>}
              <Box>
                <Button
                  sx={{ 
                    width: 'auto',
                    textDecoration: "underline"
                  }}
                  onClick={() => (window.location.href = `https://${whereFrom}`)}
                >
                  元のページへ戻る
                </Button>
              </Box>
            </Box>
          </Box>
        </Box>
        <div className="footer">
          <div className="container text-center text-white">
            supported by
            <a href="https://non-appoint.com/">
              <img src={logTop} className="footer-logo" alt="logo" />
            </a>
            <br />
            © 2022 My alarm All Rights Reserved. <br />
            運営会社:<a href="https://myalarm.site/company">My Alarm株式会社</a>
            <br />
          </div>
        </div>
      </> : <>
        <Box
          textAlign={'center'}
          color={'#fff'}
        >
          <Typography fontSize={"25px"} lineHeight={'30px'}>只今担当者を呼び出しております。<br />この画面でもう少々お待ちください。</Typography>
          <LoadingIconWrapper>
            <div className="spinner-box">
              <div className="blue-orbit leo"></div>
              <div className="green-orbit leo"></div>
              <div className="red-orbit leo"></div>
              <div className="white-orbit w1 leo"></div>
              <div className="white-orbit w2 leo"></div>
              <div className="white-orbit w3 leo"></div>
            </div>
          </LoadingIconWrapper>
          <Typography fontSize={"24px"} lineHeight={'30px'}>※通常15秒から60秒程度で繋がります。</Typography>
          {additionalUrl && <>
            <Box m={'16px 0 20px'}>
              <Button
                variant="contained"
                className="btn-white"
                onClick={() => (window.open(additionalUrl, '_blank'))}
              >うまく繋がらない場合はこちら(日程調整)</Button>
            </Box>
          </>}
          <Box mt={'20px'}>
            <a
              href={`https://${whereFrom}`}
              className={'link'}
            >元のページへ戻る</a>
          </Box>
        </Box>
      </>}
    </div>
  );
};

export default Complete;

const LoadingIconWrapper = styled.div`
  margin: 20px 0;
  @keyframes spin3D {
    from {
      transform: rotate3d(.5,.5,.5, 360deg);
    }
    to{
      transform: rotate3d(0deg);
    }
  }

  .spinner-box {
    width: 200px;
    height: 200px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: auto;
  }
  .blue-orbit {
    width: 165px;
    height: 165px;
    border: 1px solid #91daffa5;
    animation: spin3D 3s linear .2s infinite;
  }
  .green-orbit {
    width: 120px;
    height: 120px;
    border: 1px solid #91ffbfa5;
    animation: spin3D 2s linear 0s infinite;
  }
  .red-orbit {
    width: 90px;
    height: 90px;
    border: 1px solid #ffca91a5;
    animation: spin3D 1s linear 0s infinite;
  }
  .white-orbit {
    width: 60px;
    height: 60px;
    border: 2px solid #ffffff;
    animation: spin3D 10s linear 0s infinite;
  }
  .leo {
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
  }
  .w1 {
    transform: rotate3D(1, 1, 1, 90deg);
  }
  .w2 {
    transform: rotate3D(1, 2, .5, 90deg);
  }
  .w3 {
    transform: rotate3D(.5, 1, 2, 90deg);
  }
`
